import jsPDF from 'jspdf';
import 'jspdf-autotable';

const generate = (data, meta) => {
   const doc = new jsPDF();



    doc.setFontSize(18);
    doc.text(data.title, 14, 22);
    doc.setFontSize(11);
    doc.setTextColor(100);

    // jsPDF 1.4+ uses getWidth, <1.4 uses .width
    var pageSize = doc.internal.pageSize;
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
    var text = doc.splitTextToSize(data.subTitle, pageWidth - 35, {});
    doc.text(text, 14, 30);

    doc.autoTable({
        head: data.head,
        body: data.body,
        startY: 50,
    });

    doc.save(meta.fileName);
    console.log(doc);
}
 
export 
  {
    generate
  }


// WEBPACK FOOTER //
// ./src/helpers/pdf.js